// extracted by css-extract-rspack-plugin
module.exports =  {"source4":"Source4-gUXM__source4","metadata":"Source4-CI6m__metadata","link-adress":"Source4-LvJK__link-adress","not-found":"Source4-s5bZ__not-found"};